import { useMutation } from "@tanstack/react-query";
import api from "../../../../api";
import urls from "../../../../urls";
import { pollTaskStatus } from "../../../../utils/api-utils";

interface MaStRPersonImportInput {
  mastr_nummer: string;
  variant: number;
}

export function useMaStRPersonMutation() {
  return useMutation({ mutationFn: importPersonFromMaStR });
}

async function importPersonFromMaStR(
  data: MaStRPersonImportInput
): Promise<string> {
  const response = await api.post<{
    taskStatusUrl: string;
    taskIds: Array<string>;
  }>(urls.api.importPersonsFromMastr(), data);
  const { taskStatusUrl, taskIds } = response.data;

  return new Promise<string>((resolve, reject) => {
    void pollTaskStatus(
      taskStatusUrl,
      () => resolve(taskIds[0]),
      (error) => reject(error)
    );
  });
}
